import { Select } from '@appkit4/react-components/select';

interface Option {
  label: string;
  value: string;
}

interface InputDropProps {
  placeholder: string;
  value: string; // Assuming the value is a string representation of the selection
  onChange: (value: string) => void;
  testData: Option[]; // Define testData to accept an array of options
}

const InputDrop = ({ placeholder, value, onChange, testData }: InputDropProps) => {
  const handleSelectChange = (selectedValue: any) => {
    if (typeof selectedValue === 'string') {
      onChange(selectedValue);
    }
  };

  return (
    <div className='ap-field-demo-wrapper'>
      <Select
          data={testData}
              placeholder={placeholder}
          value={value}
          onSelect={handleSelectChange}>
      </Select>
    </div>
  );
}

export default InputDrop;
